import { forwardRef } from 'react'
import {
  Button as ThemeUIButton,
  ButtonProps as ThemeUIButtonProps,
} from 'theme-ui'

export type ButtonProps = ThemeUIButtonProps & {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ ...rest }, ref) => <ThemeUIButton ref={ref} {...rest} />
)
